export default __webpack_public_path__ + "static/media/icon.81c70f6f.svg";